import React from 'react';
import { useLocation } from 'react-router-dom';
import BookingModal from './BookingModal/BookingModal';



const BikeDetails = () => {
    const {state: data} = useLocation();

    const {brand, model, sellerName, sellerPhone, sellerEmail, sellerLoaction,condition,running,Engine,sellingPrice,officialPrice, img, useYears,} = data;

    console.log(data);

    return (
        <>
        <div className="card lg:w-2/3 mx-auto bg-base-100 shadow-xl my-10">
            <div className='p-10'>
                <h1 className='text-3xl font-bold text-[#009877]'>{model}</h1>
                <p className='text-xl mt-3'>{sellerLoaction}</p>
            </div>
            <figure>
                <img className='w-1/2 h-1/2' src={img} alt="Shoes" />
            </figure>
            <div className="card-body">
                <h2 className="text-2xl font-semibold text-[#009877]">Price: {sellingPrice} Tk</h2>
                
                <div className="justify-start flex-wrap text-xl">
                    <h1>Brand: {brand}</h1>
                    <h1>Model: {model}</h1>
                    <h1>Condition: {condition}</h1>
                    <h1>Engine: {Engine}</h1>
                    <h1>Running: {running}</h1>
                </div>
                <h2 className="text-2xl font-semibold text-red-400">Offical Price: {sellingPrice} Tk</h2>
                
                <label htmlFor="booking-modal" className="btn lg:w-1/3 sm:w-2/3">Booking Now</label>
            </div>
        </div>
        <BookingModal data={data}></BookingModal>
        </>

    );
};

export default BikeDetails;